import {register} from '../vendor/theme-scripts/theme-sections';
import blockScroll from '../features/block-scroll';
import {slider} from '../features/slider';

register('columns', [blockScroll, slider]);
